import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

export default function GarminCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const garminStatus = searchParams.get('garmin');
      const error = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      if (error) {
        const message = errorDescription || searchParams.get('message') || 'Connection failed';
        console.error('Garmin OAuth Error:', { error, errorDescription, message });
        toast.error(`Garmin Error: ${message}`, { duration: 10000 });
        
        setTimeout(() => navigate('/garmin-demo'), 2000);
        return;
      }

      if (garminStatus === 'connected') {
        toast.success('Garmin connected successfully! Syncing data...');
        
        try {
          await supabase.functions.invoke('sync-garmin-data');
          toast.success('Data synced successfully!');
        } catch (syncError) {
          console.error('Sync error:', syncError);
          toast.error('Connected but sync failed - please click Sync Now');
        }
        
        navigate('/garmin-demo');
        return;
      }

      setTimeout(() => navigate('/garmin-demo'), 1000);
    };

    const timeoutId = setTimeout(() => {
      console.warn('Callback timeout - redirecting to /garmin-demo');
      navigate('/garmin-demo');
    }, 5000);

    handleCallback().finally(() => clearTimeout(timeoutId));

    return () => clearTimeout(timeoutId);
  }, [searchParams, navigate]);

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
        <p className="text-muted-foreground mb-2">Connecting your Garmin account...</p>
        {error && (
          <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
            <p className="text-sm text-destructive font-medium">Error: {error}</p>
            {errorDescription && (
              <p className="text-xs text-muted-foreground mt-1">{errorDescription}</p>
            )}
            <p className="text-xs text-muted-foreground mt-2">Redirecting back...</p>
          </div>
        )}
      </div>
    </div>
  );
}
